import React from 'react'
import clsx from 'clsx'
import {
  Autocomplete,
  CircularProgress,
  TextField,
  IconButton,
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import DeleteIcon from '@mui/icons-material/Delete'

export default function StockSheet({
  classes,
  filterProducts,
  productLoading,
  stockItems,
  columns,
  onAdd,
  onCellEditStart,
  onCellEditCommit,
  onSelectionChange,
  deleteOn,
  onDeleteClick,
}) {
  const ClickToDeleteStockItemButton =
    deleteOn ? (
      <IconButton
        className={classes.deleteButton}
        color="primary"
        aria-label="delete stock item"
        onClick={onDeleteClick}
        size="large"
      >
        <DeleteIcon style={{ fontSize: 60 }} />
      </IconButton>
    ) : (
      ''
    )

  return (
    <div>
      <Autocomplete
        className={clsx(classes.content, classes)}
        id="products"
        autoHighlight
        variant="standard"
        options={filterProducts}
        getOptionLabel={(option) => option.title + ', ' + option.nappiCode}
        renderInput={(params) => (
          <TextField {...params} label="Products" variant="outlined" />
        )}
        onChange={(event, product) => {
          onAdd(product)
        }}
      />
      {productLoading && <CircularProgress size={40} className={classes.pprogress} />}

      <div style={{ width: '100%', height: '380pt', backgroundColor: '#ffffff' }}>
        <DataGrid
          rows={stockItems}
          columns={columns}
          onCellEditCommit={onCellEditCommit}
          onCellEditStart={onCellEditStart}
          isRowSelectable={() => true}
          onSelectionModelChange={onSelectionChange}
        />
      </div>
      {ClickToDeleteStockItemButton}
    </div>
  )
}
